//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ArzyptoApplication',
  data () {
    return {
      titles: [this.$t('common.exchangeMarket'), this.$t('common.instantTransaction'), this.$t('common.assetManagment'), this.$t('common.priceAlert')]
    }
  },
  methods: {
    open () {
      this.$refs.mySheet.open()
    },
    close () {
      this.$refs.mySheet.close()
    }
  }
}
